<template>
  <div class="container test-results">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-wrapper">
          <h1 class="title">Your hearing loss test results</h1>
        </div>
        <div class="title-divider"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="position-wrapper">
          <div @click="showOnly('L')" class="left-wrapper">
            <div :style="{backgroundColor: visible.L ? '#0e9fcc' : '#fff'}" class="left-line"></div>
            <p>Left</p>
          </div>
          <div @click="showOnly('R')" class="right-wrapper">
            <div :style="{backgroundColor: visible.R ? '#fe4a49' : '#fff'}" class="right-line"></div>
            <p>Right</p>
          </div>
        </div>
      </div>
    </div>

    <Chart v-model="visible"/>

    <div class="row">
      <div class="col-sm-12">
        <div class="description-wrapper">
          <p v-show="anomalies.L.length || anomalies.R.length">
            The tonal test detected suboptimal hearing. The results show some
            issues in picking up both higher and lower-pitched sounds. In
            particular, there might be an anomaly with the frequency:
            <span v-show="visible.L" style="color: #0e9fcc">
              <br>
              L:
              <template v-for="(freq, i) in anomalies.L">{{i > 0 ? ', ' : ''}}{{freq}}</template>
            </span>
            <span v-show="visible.R" style="color: #fe4a49">
              <br>
              R:
              <template v-for="(freq, i) in anomalies.R">{{i > 0 ? ', ' : ''}}{{freq}}</template>
            </span>
          </p>
          <p>
            Your hearing loss can be classified as
            <span :class="classification" class="severity">{{ classification }}</span> in
            <router-link to="/who-classification-criteria">WHO hearing loss classification criteria</router-link>
            .
          </p>
          <p>
            Please call Lloyd Hearing Aid toll free at 1-800-323-4212 to speak with a licensed hearing aid professional
            to discuss your test results.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="button-wrapper">
          <router-link to="/select-gender" class="button-main">re-test</router-link>
          <router-link to="/phonems-audiogram-results" class="button-main">next step</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Chart from "../components/Chart";
  import EventBus from "../EventBus";

  export default {
    mounted() {
      EventBus.$on('newAnomaly', ({side, tone}) => {
        this.anomalies[side].push(tone)
      })
      EventBus.$on('updateClassification', classification => {
        this.classification = classification
      })
    },
    components: {Chart},
    data() {
      return {
        visible: {
          L: true,
          R: true
        },
        anomalies:{
          L: [],
          R: []
        },
        classification: 'normal',
      }
    },
    methods: {
      showOnly(key) {
        EventBus.$emit('showOnly', key)
      }
    }
  }
</script>
